<template>
  <div class="min-h-screen bg-black text-white flex flex-col items-center justify-center p-6">
    <a href="/" class="mb-8"><img src="/images/logo_testo.png" alt="StreetStock Logo" class="h-12" /></a>
    <h1 class="text-2xl font-bold mb-6">Scegli il tuo negozio (1/3)</h1>

    <div class="w-full max-w-xs city-list">
      <!-- 🔹 Primo bottone: link al sito -->
      <a href="https://rdnstreetmarket.it" target="_blank" rel="noopener"
        class="btn w-full text-center py-3 rounded-xl font-semibold">
        RdnStreetMarket.it
      </a>
      
      <a v-for="s in stores" :key="s.city" href="#" class="btn w-full text-center py-3 rounded-xl font-semibold"
        @click.prevent="choose(s)">
        {{ s.city }}
      </a>
    </div>
  </div>
</template>

<script>
import stores from '@/stores'

export default {
  name: 'SelectStore',
  data() { return { stores } },
  methods: {
    choose(store) {
      // salvo scelta
      localStorage.setItem('ss_selected_store', JSON.stringify(store))
      // avanti
      window.location.href = '/join/save-contact'
    }
  }
}
</script>

<style scoped>
.city-list {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.btn {
  background: #3aa7df;
  color: #fff;
  text-decoration: none;
  transition: background .2s;
}

.btn:hover {
  background: #2f93c6;
}
</style>
